import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { UnitofmeasurementcultureEditService } from '../../service/unitofmeasurementculture-edit/unitofmeasurementculture-edit.service';

@Component({
	selector: 'app-unitofmeasurementculture-edit',
	templateUrl: './unitofmeasurementculture-edit.component.html',
	providers: [
		UnitofmeasurementcultureEditService,
		HttpModule
	]
})
export class UnitofmeasurementcultureEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	unit: FormGroup;
	ID: string;
	Nome: string;
	Sigla: string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private UnitofmeasurementcultureEditService: UnitofmeasurementcultureEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.unit = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Sigla': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.UnitofmeasurementcultureEditService.loadUnit(this.token, this.ID).subscribe(result => {
				var updateUnit = result.Result;
				this.unit.setValue({
					ID: updateUnit.ID,
					Nome: updateUnit.Nome,
					Sigla: updateUnit.Sigla,
					Ativo: updateUnit.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editUnit(value: any) {
		this.UnitofmeasurementcultureEditService.editUnit(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Unidade de Medida Cultura editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/unidade-medida-cultura');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/unidade-medida-cultura');
	}

}



// WEBPACK FOOTER //
// ./src/app/unitofmeasurementculture/component/unitofmeasurementculture-edit/unitofmeasurementculture-edit.component.ts